module.exports = __webpack_public_path__ + "img/logo-opsional2.e15b64f1.png";